"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IS_RECORD_SENTINEL = exports.IS_ORDERED_SENTINEL = exports.IS_INDEXED_SENTINEL = exports.IS_KEYED_SENTINEL = exports.IS_ITERABLE_SENTINEL = exports.isValueObject = exports.isVersion3Record = exports.isRecord = exports.isOrdered = exports.isAssociative = exports.isIndexed = exports.isKeyed = exports.isCollection = exports._isImmutableNoRecordChecks = exports.isImmutable = void 0;
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var isImmutable = function isImmutable(maybeImmutable) {
  return isCollection(maybeImmutable) || isRecord(maybeImmutable);
};

exports.isImmutable = isImmutable;

var _isImmutableNoRecordChecks = function _isImmutableNoRecordChecks(ii) {
  return !ii ? false : !!ii[IS_ITERABLE_SENTINEL];
};

exports._isImmutableNoRecordChecks = _isImmutableNoRecordChecks;

var isCollection = function isCollection(ii) {
  return !ii ? false : !!(ii[IS_ITERABLE_SENTINEL] && !isVersion3Record(ii));
};

exports.isCollection = isCollection;

var isKeyed = function isKeyed(ii) {
  return !ii ? false : !!(ii[IS_KEYED_SENTINEL] && !isVersion3Record(ii));
};

exports.isKeyed = isKeyed;

var isIndexed = function isIndexed(ii) {
  return !ii ? false : !!ii[IS_INDEXED_SENTINEL];
};

exports.isIndexed = isIndexed;

var isAssociative = function isAssociative(ii) {
  return isKeyed(ii) || isIndexed(ii);
};

exports.isAssociative = isAssociative;

var isOrdered = function isOrdered(ii) {
  return !ii ? false : !!ii[IS_ORDERED_SENTINEL];
};

exports.isOrdered = isOrdered;

var isRecord = function isRecord(ii) {
  return !ii ? false : !!(ii[IS_RECORD_SENTINEL] || isVersion3Record(ii));
};

exports.isRecord = isRecord;

var isVersion3Record = function isVersion3Record(ii) {
  return !!ii._defaultValues;
};

exports.isVersion3Record = isVersion3Record;

var isValueObject = function isValueObject(ii) {
  return !ii ? false : typeof ii.equals === 'function' && typeof ii.hashCode === 'function';
};

exports.isValueObject = isValueObject;
var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
exports.IS_ITERABLE_SENTINEL = IS_ITERABLE_SENTINEL;
var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
exports.IS_KEYED_SENTINEL = IS_KEYED_SENTINEL;
var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
exports.IS_INDEXED_SENTINEL = IS_INDEXED_SENTINEL;
var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
exports.IS_ORDERED_SENTINEL = IS_ORDERED_SENTINEL;
var IS_RECORD_SENTINEL = '@@__IMMUTABLE_RECORD__@@';
exports.IS_RECORD_SENTINEL = IS_RECORD_SENTINEL;